/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Sections components

// Avatars page components

// Avatars page components code

import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux"; // 存储状态，可以在其他页面上获取状态
import Grid2 from "@mui/material/Unstable_Grid2";
import MKBox from "../../components/MKBox";
import { RETURN_DATA_COLLECTIONS } from "../../store/actions";
import CollectionHub from "../../views/CollectionHub";
import bgImage from "../../assets/images/backgrounds/bg-global012.png";

// eslint-disable-next-line import/no-cycle
import MainLayout from "../MainLayout";
import MKTypography from "../../components/MKTypography";
import HTTP_API from "../../store/constant/httpApi";

const DataHub = () => {
  const dispatch = useDispatch();
  const [ReturnCollections, setReturnCollections] = useState([]); // ReturnCollections is a state, setReturnCollections is only way to set value of ReturnCollections
  const BreadcrumbsRoutes = [{ label: "Home", route: "/home" }, { label: "Data" }];

  useEffect(async () => {
    if (ReturnCollections.length === 0) {
      await axios // axios 是对ajax的一个高级封装，拥有promise.then异步获取远程数据的方法
        .get(`${HTTP_API.STAC}/collections`)
        .then((r) => {
          dispatch({ type: RETURN_DATA_COLLECTIONS, value: r.data.data_collections }); // set return data collections to reducer action RETURN_DATA_COLLECTIONS to save in redux
          setReturnCollections(r.data.collections);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, []);
  return (
    <MainLayout breadcrumbsRoutes={BreadcrumbsRoutes}>
      <MKBox component="section" sx={{ height: "87vh", overflow: "auto" }}>
        <MKBox
          width={1}
          height="25vh"
          bgColor="white"
          sx={{
            alignItems: "center",
            backgroundImage: ({ palette: { dark, black }, functions: { linearGradient, rgba } }) =>
              `${linearGradient(rgba(dark.main, 0.2), rgba(black.main, 0.6))}, url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "grid",
          }}
        >
          <MKBox
            mx={{ sm: 3, xl: 12, xxl: 24, xxxl: 36, xxxxl: 72 }}
            justifyContent={{ lg: "left", sm: "center" }}
          >
            <Grid2 container>
              <Grid2 xs={12} lg={7} xxl={6} xxxl={5}>
                <MKTypography variant="h2" color="white" textAlign="left">
                  Large area, high resolution and geographical features.
                </MKTypography>
              </Grid2>
            </Grid2>
          </MKBox>
        </MKBox>
        <MKBox bgColor="white">
          <Grid2 container>
            <CollectionHub collections={ReturnCollections} linkPrefix="/data-map/" />
          </Grid2>
        </MKBox>
      </MKBox>
    </MainLayout>
  );
};

export default DataHub;
